export default {
  index: [
    {
      path: '/warehouse',
      component: resolve => require(['./warehouseIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/warehouse/_router.js